export default "__VITE_ASSET__Cp2S_Pw5__"